import { useField } from "formik";
import React, { useEffect, useState } from "react";

import DonationSelector, { defaultDonationOptions } from "components/DonationSelector/DonationSelector";
import ErrorDisplay from "components/ErrorDisplay";

import { usePrevious } from "helpers/previousHook";

export const generateDonationOptions = (donationFrequency, donationFormData) => {
  let options = defaultDonationOptions;

  if (donationFormData?.donationOptions) {
    options = donationFormData.donationOptions;
  }

  return options;
};

export const DonationSelectorWrapper = ({ label, ...props }) => {
  const frequency = props.values.frequency;
  const [selectedIndex, setSelectedIndex] = useState();
  const previousFrequency = usePrevious(frequency);
  const [field, meta] = useField(props);
  const {
    feeStructure,
  } = props.data;

  const { handleDonationAmountChanges } = props.handlers;
  const donationOptions = generateDonationOptions(frequency, props.data);

  /* eslint react-hooks/exhaustive-deps: "off" */
  useEffect(() => {
    if (props?.data?.prefill?.donationAmount) {
      handleDonationAmountChanges(
        props?.data?.prefill?.donationAmount,
        props.data,
        props,
        props.donationFormContext.optionalTier,
      );
    }
  }, [props?.data]);

  useEffect(() => {
    // update donation amount if frequency is different and defaultPaymentMethod is regular (allows different donation options based on regular giving toggle)
    if (previousFrequency && (frequency !== previousFrequency) && props?.data?.defaultPaymentMethod === "regular") {
      const updatedDonationValue = selectedIndex === -1
        ? props.values.donationAmount
        : Object.values(donationOptions)[selectedIndex];
      props.setFieldValue("donationAmount", updatedDonationValue);
      handleDonationAmountChanges(updatedDonationValue, props.data, props, props.donationFormContext.optionalTier);
    }
  }, [frequency, previousFrequency, donationOptions, handleDonationAmountChanges, props, selectedIndex]);

  const changeDonationAmount = (
    value,
  ) => handleDonationAmountChanges(value, props.data, props, props.donationFormContext.optionalTier);

  return (
    <section>
      <ErrorDisplay
        alwaysShowErrors={meta.touched && meta.error?.length > 0}
        customMsg={meta.error}
        field={field}
      >
        <DonationSelector
          currencySymbol={feeStructure.currencySymbol}
          currencyText={feeStructure.currency}
          donationOptions={donationOptions}
          setFieldValue={(value) => props.setFieldValue("donationAmount", value)}
          handleDonationAmountChange={changeDonationAmount}
          setSelectedIndex={setSelectedIndex}
          initialValue={props?.data?.prefill?.donationAmount}
          openCurrencyModal={props.handlers.openCurrencyModal()}
          showCurrencySelector
          {...field}
        />
      </ErrorDisplay>
    </section>
  );
};

export const createDonationSelector = (data, i, formProps, handlers, donationFormContext) => (
  <DonationSelectorWrapper
    key={i}
    label="Donation Selector"
    name="donationAmount"
    type="text"
    data={data}
    handlers={handlers}
    donationFormContext={donationFormContext}
    {...formProps}
  />
);
